import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function SiteHeader() {
  const { user } = useAuth();
  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-black/80 border-b border-zinc-800/80">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-4 flex items-center justify-between gap-4">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3 group">
          <img src="/images/mpb-shield.png" alt="Masters Pro Boxing" className="h-12 w-12 object-contain rounded" />
          <span className="font-display text-xl sm:text-2xl tracking-[0.15em] text-white">
            MASTERS <span className="text-[#E10600]">PRO</span> BOXING
          </span>
        </Link>
        <div className="flex items-center gap-3 sm:gap-6">
          <span className="hidden md:flex items-center gap-2 font-mono2 text-[10px] tracking-[0.25em] text-zinc-500 uppercase" data-testid="header-ibc-badge">
            Affiliated with <img src="/images/ibc-logo.webp" alt="IBC" className="h-4 w-4 object-contain" /> <span className="text-zinc-300">IBC</span>
          </span>
          {user && user.role === "fighter" ? (
            <Link
              to="/dashboard"
              data-testid="header-fighter-login-btn"
              className="font-cond font-semibold tracking-[0.2em] text-xs sm:text-sm border border-zinc-700 hover:border-[#E10600] hover:text-[#E10600] text-zinc-200 px-4 sm:px-6 py-2.5 transition-colors duration-300"
            >
              MY LOCKER ROOM
            </Link>
          ) : (
            <Link
              to="/login"
              data-testid="header-fighter-login-btn"
              className="font-cond font-semibold tracking-[0.2em] text-xs sm:text-sm border border-zinc-700 hover:border-[#E10600] hover:text-[#E10600] text-zinc-200 px-4 sm:px-6 py-2.5 transition-colors duration-300"
            >
              FIGHTER LOGIN
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
